export default "__VITE_ASSET__be428217__"